<template>
    <svg width="33" height="33" viewBox="0 0 27 27" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="b-icon bi">
        <path
            d="M15.8333 8.83333L14.6666 10L16.8333 12.1667H8.33325V13.8333H16.8333L14.6666 16L15.8333 17.1667L19.9999 13L15.8333 8.83333ZM23.3333 18.8333H16.6666V20.5H23.3333C24.2499 20.5 24.9999 19.75 24.9999 18.8333V7.16667C24.9999 6.25 24.2499 5.5 23.3333 5.5H16.6666V7.16667H23.3333V18.8333Z"
            fill="currentColor"
        />
        <path
            d="M10.8334 17.1667L12 16L9.83337 13.8333H18.3334V12.1667L9.83337 12.1667L12 10L10.8334 8.83333L6.66671 13L10.8334 17.1667ZM3.33337 7.16667H10V5.5H3.33337C2.41671 5.5 1.66671 6.25 1.66671 7.16667V18.8333C1.66671 19.75 2.41671 20.5 3.33337 20.5L10 20.5V18.8333H3.33337L3.33337 7.16667Z"
            fill="currentColor"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'IconMerge',
})
</script>
